import React from 'react';
import { Navigate } from 'react-router-dom';
import { Briefcase } from 'lucide-react';
import AppHeader from '../components/layout/AppHeader';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import LaunchDealList from '../components/launches/LaunchDealList';
import { useBusinessUnit } from '../hooks/useBusinessUnit';

export default function LaunchDealsPage() {
  const { availableUnits, isLoading } = useBusinessUnit();

  if (isLoading) {
    return (
      <>
        <AppHeader title="Deals — Empreendimentos" icon={Briefcase} />
        <div className="p-6"><LoadingSpinner /></div>
      </>
    );
  }

  if (!availableUnits || !availableUnits.includes('launches')) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <AppHeader title="Deals — Empreendimentos" subtitle="launch_deals" icon={Briefcase} />
      <div className="p-4 lg:p-6">
        <LaunchDealList />
      </div>
    </>
  );
}
